import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './AvaliacaoForm.css';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function SliderNota({ label, descricao, peso, name, value, onChange }) {
  const pct = (parseFloat(value) / 10) * 100;
  return (
    <div className="avf-criterio">
      <div className="avf-criterio-top">
        <div className="avf-criterio-info">
          <span className="avf-criterio-label">{label}</span>
          {descricao && <span className="avf-criterio-desc">{descricao}</span>}
        </div>
        <div className="avf-criterio-right">
          <span className="avf-peso-tag">Peso {peso} · máx {peso * 10}</span>
          <span className="avf-nota-box">{parseFloat(value).toFixed(1)}</span>
        </div>
      </div>
      <input
        type="range" min="0" max="10" step="0.5"
        name={name} value={value} onChange={onChange}
        className="avf-slider"
        style={{'--pct': pct + '%'}}
      />
      <div className="avf-slider-labels">
        <span>0</span><span>2.5</span><span>5</span><span>7.5</span><span>10</span>
      </div>
    </div>
  );
}

function AvaliacaoForm({ apresentacao, onAvaliacaoSucesso, onCancel, onErroDuplicata }) {
  const [formData, setFormData] = useState({
    apresentacao: apresentacao.id,
    nota_originalidade: '5',
    nota_relevancia_cientifica: '5',
    nota_qualidade_metodologica: '5',
    nota_consistencia_resultados: '5',
    nota_impacto_clinico: '5',
  });

  const notaPrevia =
    (parseFloat(formData.nota_originalidade) * 1.5) +
    (parseFloat(formData.nota_relevancia_cientifica) * 2) +
    (parseFloat(formData.nota_qualidade_metodologica) * 2.5) +
    (parseFloat(formData.nota_consistencia_resultados) * 2.5) +
    (parseFloat(formData.nota_impacto_clinico) * 1.5);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const csrftoken = getCookie('csrftoken');
    const config = { headers: { 'X-CSRFToken': csrftoken } };
    const dataToSend = {
      apresentacao: formData.apresentacao,
      nota_originalidade: formData.nota_originalidade,
      nota_relevancia_cientifica: formData.nota_relevancia_cientifica,
      nota_qualidade_metodologica: formData.nota_qualidade_metodologica,
      nota_consistencia_resultados: formData.nota_consistencia_resultados,
      nota_impacto_clinico: formData.nota_impacto_clinico,
    };
    axios.post('/api/avaliacoes/', dataToSend, config)
      .then(() => {
        toast.success('Avaliação enviada com sucesso!');
        onAvaliacaoSucesso(apresentacao.id);
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          if (error.response.data && error.response.data.non_field_errors) {
            toast.error('Este tema já foi avaliado por você.');
            onErroDuplicata(apresentacao.id);
          } else {
            toast.error('Erro de validação nos dados enviados.');
          }
        } else {
          toast.error('Ocorreu um erro de rede. Tente novamente.');
        }
      });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content avf-modal">

        {/* Header */}
        <div className="avf-header">
          <h3 className="avf-titulo">Avaliar Apresentação</h3>
          <p className="avf-subtitulo">"{apresentacao.titulo}"</p>
          <p className="avf-apresentador">👤 {apresentacao.apresentador_principal}</p>
          {apresentacao.lista_autores?.trim() && (
            <p className="avf-autores">👥 Autores: {apresentacao.lista_autores}</p>
          )}
        </div>

        <form onSubmit={handleSubmit} className="avf-form">

          {/* 1. Originalidade */}
          <SliderNota
            label="1. Originalidade"
            descricao="Inovação da proposta e contribuição ao conhecimento"
            peso={1.5}
            name="nota_originalidade"
            value={formData.nota_originalidade}
            onChange={handleChange}
          />

          {/* 2. Relevância Científica */}
          <SliderNota
            label="2. Relevância Científica"
            descricao="Importância científica e contribuição para a área"
            peso={2}
            name="nota_relevancia_cientifica"
            value={formData.nota_relevancia_cientifica}
            onChange={handleChange}
          />

          {/* 3. Qualidade metodológica */}
          <SliderNota
            label="3. Qualidade Metodológica"
            descricao="Adequação do desenho, métodos e análise"
            peso={2.5}
            name="nota_qualidade_metodologica"
            value={formData.nota_qualidade_metodologica}
            onChange={handleChange}
          />

          {/* 4. Consistência dos resultados */}
          <SliderNota
            label="4. Consistência dos Resultados"
            descricao="Coerência entre dados, resultados e conclusões"
            peso={2.5}
            name="nota_consistencia_resultados"
            value={formData.nota_consistencia_resultados}
            onChange={handleChange}
          />

          {/* 5. Impacto clínico */}
          <SliderNota
            label="5. Impacto Clínico"
            descricao="Aplicabilidade e benefício potencial à prática clínica"
            peso={1.5}
            name="nota_impacto_clinico"
            value={formData.nota_impacto_clinico}
            onChange={handleChange}
          />

          {/* Prévia da nota */}
          <div className="avf-previa">
            <span className="avf-previa-label">Nota Final Prévia</span>
            <span className={'avf-previa-nota ' + (notaPrevia >= 80 ? 'avf-nota-alta' : notaPrevia >= 60 ? 'avf-nota-media' : 'avf-nota-baixa')}>
              {notaPrevia.toFixed(1)}
              <span className="avf-previa-max">/100</span>
            </span>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-submit">
              Enviar Avaliação
            </button>
            <button type="button" className="btn-close" onClick={onCancel}>Fechar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AvaliacaoForm;
